import { type PropsWithChildren } from "react";

import * as S from "./ScrollShadowContainer.styled";
import {
  useShadowVisible,
  type ShadowVisibleChange,
} from "./ScrollShadowContainer.utils";

export type ScrollShadowContainerProps = PropsWithChildren & {
  tabIndex?: -1 | 0;
  onChange?: ShadowVisibleChange;
};

function ScrollShadowContainer(props: ScrollShadowContainerProps) {
  const { tabIndex, onChange, children } = props;

  const {
    topShadowRef,
    bottomShadowRef,
    topShadowVisible,
    bottomShadowVisible,
  } = useShadowVisible(onChange);

  return (
    <S.Container>
      <S.TopShadow $visible={topShadowVisible} />

      <S.ScrollContainer tabIndex={tabIndex}>
        <div ref={topShadowRef} />

        {children}

        <div ref={bottomShadowRef} />
      </S.ScrollContainer>

      <S.BottomShadow $visible={bottomShadowVisible} />
    </S.Container>
  );
}

export default ScrollShadowContainer;
